// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBXh4hmn_v_DHKnrwHdYXAoarfZDeWUc_0",
  authDomain: "netflixgpt-2c863.firebaseapp.com",
  projectId: "netflixgpt-2c863",
  storageBucket: "netflixgpt-2c863.firebasestorage.app",
  messagingSenderId: "301544802097",
  appId: "1:301544802097:web:ac98ca30b469ad1d269210",
  measurementId: "G-MLYELP6C3H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth();